<template>
<div class="chapter">
<div class="inner_page">
<div id="fm_02">
<p class="half"><span>Crush</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Half_Title.vue?2a4b5b72